import { BodyText, Callout } from "@/components/ui";
import { Link } from "@tanstack/react-router";
import { MissingPatientDetails } from "../../network/usePrescriptions";

const missingPatientDetailsMap: Record<
  MissingPatientDetails,
  { display: string; medicalRecordsTab?: string }
> = {
  [MissingPatientDetails.FIRST_NAME]: { display: "First Name" },
  [MissingPatientDetails.LAST_NAME]: { display: "Last Name" },
  [MissingPatientDetails.DATE_OF_BIRTH]: { display: "Date of Birth" },
  [MissingPatientDetails.GENDER]: { display: "Gender" },
  [MissingPatientDetails.ADDRESS]: {
    display: "Address",
    medicalRecordsTab: "profile",
  },
  [MissingPatientDetails.CITY]: {
    display: "City",
    medicalRecordsTab: "profile",
  },
  [MissingPatientDetails.STATE]: {
    display: "State",
    medicalRecordsTab: "profile",
  },
  [MissingPatientDetails.ZIP]: { display: "Zip", medicalRecordsTab: "profile" },
  [MissingPatientDetails.PHONE]: {
    display: "Phone",
    medicalRecordsTab: "profile",
  },
};

export const MissingPatientDetailsCallout = ({
  missingPatientDetails,
  heightWeightNeeded,
  patientId,
}: {
  missingPatientDetails: MissingPatientDetails[];
  heightWeightNeeded: boolean;
  patientId: string;
}) => {
  return (
    <Callout title="Missing Patient Details" variant="warning">
      <div className="flex flex-col gap-2">
        <BodyText size="sm">
          This patient is not registered with Dosespot. Ordering electronically
          and interaction checking will not be available until the patient is
          registered with Dosespot. The prescription can still be phoned in. The
          following patient details are missing:
          <ul className="list-outside list-disc pl-5 mt-2">
            {missingPatientDetails?.map((detail) => (
              <li key={detail}>
                {missingPatientDetailsMap[detail].medicalRecordsTab ? (
                  <Link
                    // @ts-expect-error - medicalRecordsTab must be a route in the route tree
                    to={`/patient/$patientId/${missingPatientDetailsMap[detail].medicalRecordsTab}`}
                    params={{ patientId: patientId }}
                    search={(prevSearch) => ({
                      ...prevSearch,
                    })}
                  >
                    <BodyText
                      size="sm"
                      textColor="link"
                      bold
                      className="cursor-pointer"
                    >
                      {missingPatientDetailsMap[detail].display}
                    </BodyText>
                  </Link>
                ) : (
                  <BodyText size="sm">
                    {`${missingPatientDetailsMap[detail].display}: Contact support to update`}
                  </BodyText>
                )}
              </li>
            ))}
            {heightWeightNeeded && (
              <li>
                <Link
                  to="/patient/$patientId/vitals"
                  params={{ patientId: patientId }}
                  search={(prevSearch) => ({
                    ...prevSearch,
                  })}
                >
                  <BodyText
                    size="sm"
                    textColor="link"
                    bold
                    className="cursor-pointer"
                  >
                    Height and Weight
                  </BodyText>
                </Link>
              </li>
            )}
          </ul>
        </BodyText>
      </div>
    </Callout>
  );
};
